<template>
  <div>
    <section class="forms component product_review_form" resmed-component-name="product_review" v-bind:class="name"
              v-bind:style="{
               'background-image': `url(${acf.layout['background-image']})`,
               'background-color': acf.layout['background-color']
              }">
        <div class="container">
            <div class="row">
                <div class="col">
                    <component v-bind:is="active" v-bind:acf="acf"></component>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
    import forms from '../forms/index';
    import marketo from '../../mixins/marketo-form';

    export default {
        name: 'component-0b2c6199',
        mixins: [ marketo ],
        components: {
            ...forms
        },
        props: ['acf', 'name','origin'],
        created() {
            bus.$emit('navigation:reversed', true);
        },
        mounted() {
          this.get_marketo();
        },
        computed: {
            active() {
                const name = this.name.replace(/\s/, '-').toLowerCase();
                return `form-${name}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .component-0b2c6199{
        .forms.component {
            min-height: 100vh;
            display: flex;
            display: -ms-flexbox;
            display: -webkit-flex;
            align-items: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
        }
        .forms.component:after{
            content:'';
            min-height:inherit;
            font-size:0;
        }
        .forms.component.product_review_form {
            background-position-y: 50px;
            background-size: 1100px 1100px;       
        }
    }


    @media (max-width: 767px) {
        .component-0b2c6199{
            .forms.component.product_review_form {
                background-image: none !important;
                background-color: white !important;
            }

        }
    }
    @media (min-width: 768px) and (max-width: 991px) { 
        .component-0b2c6199{
            .forms.component.product_review_form {
                background-size: 806px 807px;
            }
        }
    }




</style>